import { useEffect } from "react";

import { formatter } from "../../helpers/helpers.ts";
import useAddToCart from "../../hooks/useAddToCart.ts";
import { useBooking } from "../../providers/BookingProvider.tsx";
import { useVehicleSelection } from "../../providers/VehicleSelectionContext.tsx";
import Button from "../elements/Button.tsx";
import Header from "../elements/Header.tsx";
import CartWarningModal from "../modals/CartWarningModal.tsx";
import InvalidNonceModal from "../modals/InvalidNonceModal.tsx";
import ValidationErrorModal from "../modals/ValidationErrorModal.tsx";

export const OrderFooter = () => {
  const { orderMode, pricing, selectedGvmUpgrade } = useVehicleSelection();
  const { order } = useBooking();

  const {
    triggerAddToCart,
    isLoading,
    error: cartError,
    clearError,
  } = useAddToCart();

  useEffect(() => {
    if (!cartError) {
      return;
    }

    if (cartError.type === "generic") {
      alert(cartError.message);
      clearError();
    }
  }, [cartError, clearError]);

  return (
    <>
      <div>
        <div className="flex justify-between items-center">
          <Header
            size="3xl"
            hideUnderline
            className="text-white lg:text-black uppercase"
          >
            Complete Package
          </Header>
          <Header size="2xl" hideUnderline className="text-white lg:text-black">
            {formatter.format(pricing.total)}
          </Header>
        </div>

        {orderMode === "editing" && order && (
          <>
            <div className="bg-primary text-white -mx-4 p-4 my-2">
              <div>
                The previous upgrade kit will be removed from the order and
                replaced with the kit above.
              </div>
              <div>
                {pricing.total !== Number(order.totals.total_price) / 100 ? (
                  <>
                    The total price of the order will change from{" "}
                    <span className="font-semibold">
                      {formatter.format(Number(order.totals.total_price) / 100)}
                    </span>{" "}
                    to{" "}
                    <span className="font-semibold">
                      {formatter.format(pricing.total)}
                    </span>
                    .
                  </>
                ) : (
                  <>The total price of the order will be unchanged.</>
                )}
              </div>
            </div>
          </>
        )}

        <div className="flex flex-col lg:flex-row justify-between items-center mt-2">
          <div className="text-2xs text-white lg:text-black">
            {orderMode === "new" && (
              <>
                <div>Please note pricing is indicative.</div>
                <div>
                  Continue to complete all steps for the most accurate pricing.
                </div>
              </>
            )}
          </div>
          <div className="lg:text-right">
            {selectedGvmUpgrade && (
              <>
                {selectedGvmUpgrade.is_purchasable ? (
                  <Button
                    onClick={() => triggerAddToCart()}
                    disabled={isLoading}
                  >
                    {orderMode === "new" ? "Continue" : "Update Order"}
                  </Button>
                ) : (
                  <Button disabled>Unavailable</Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {cartError?.type === "cart-not-empty" && (
        <CartWarningModal onClose={() => clearError()} justHappened />
      )}
      {cartError?.type === "validation" && (
        <ValidationErrorModal onClose={() => clearError()} />
      )}
      {cartError?.type === "invalid-nonce" && (
        <InvalidNonceModal onClose={() => clearError()} />
      )}
    </>
  );
};
